import ImageWithFallback from 'gcs-common/design-system/ui/image-with-fallback';
import etsIcon from 'gcs-common/img/ets_icon.svg';

interface TicketListItemProps {
  thumbnail: string;
}
const etsIconImage = () => {
  return <img src={etsIcon} alt="Bild" className="h-12 w-12 rounded-xl object-cover p-0" />;
};

const TicketAttachmentThumbnail = (props: TicketListItemProps) => {
  const { thumbnail } = props;
  return (
    <div className="h-12 w-12 flex-shrink-0 overflow-hidden rounded-xl">
      <ImageWithFallback
        className="h-full w-full rounded-xl object-cover p-0"
        src={thumbnail}
        fallback={etsIconImage()}
        alt="Bild"
      />
    </div>
  );
};

export default TicketAttachmentThumbnail;
